const ecAjax = require('./utils/ec-ajax');
const ecAuth = require('./utils/ec-auth');
const ecCommon = require('./utils/ec-common');
const ecDate = require('./utils/ec-date');
const ecNumber = require('./utils/ec-number');
const ecPopup = require('./utils/ec-popup');
const ecString = require('./utils/ec-string');
const ecUi = require('./utils/ec-ui');
const ecValidator = require('./utils/ec-validator');

module.exports = {
    AjaxUtil: ecAjax,
    AuthUtil: ecAuth,
    CommonUtil: ecCommon,
    DateUtil: ecDate,
    NumberUtil: ecNumber,
    PopupUtil: ecPopup,
    StringUtil: ecString,
    UiUtil: ecUi,
    ValidatorUtil: ecValidator,
};



// WEBPACK FOOTER //
// ./src/entry-utils.js